import { CardContent, Grid2 as Grid, Typography, Card } from "@mui/material"
import React from "react"
import { RightioWBSAPIModelsSPSpBookingGetLastJobResult, RightioWBSAPIModelsSPSpJobsGetJobDetailsResult } from "@utils/apis/wbs/endpoints"
import statuses from "../statuses"

const name = "BookingCard"

type BookingCardProps = {
    parent: string
    job?: RightioWBSAPIModelsSPSpBookingGetLastJobResult
    jobDetails: RightioWBSAPIModelsSPSpJobsGetJobDetailsResult | undefined
}

const BookingCard: React.FC<BookingCardProps> = ({ parent, job, jobDetails }) => {

    return (
        (< Card sx={{ mb: 1 }}>
            <CardContent>
                {jobDetails?.areaNumber &&
                    <Grid container>
                        <Grid size={6}>
                            <Typography sx={{ textAlign: "right", pr: 2 }} variant="body1" >Area Number:</Typography>
                        </Grid>
                        <Grid size={6}>
                            <Typography variant="body1" ><span style={{ color: "blue" }}>{jobDetails?.areaNumber}</span></Typography>
                        </Grid>
                    </Grid>}
                {jobDetails?.postcodeDistrict &&
                    <Grid container>
                        <Grid size={6}>
                            <Typography sx={{ textAlign: "right", pr: 2 }} variant="body1" >District:</Typography>
                        </Grid>
                        <Grid size={6}>
                            <Typography variant="body1" ><span style={{ color: "blue" }}>{jobDetails?.postcodeDistrict}</span></Typography>
                        </Grid>
                    </Grid>}
                {jobDetails?.statusId &&
                    <Grid container>
                        <Grid size={6}>
                            <Typography sx={{ textAlign: "right", pr: 2 }} variant="body1" >Status:</Typography>
                        </Grid>
                        <Grid size={6}>
                            <Typography variant="body1" ><span style={{ color: statuses[jobDetails?.statusId].color || "blue" }}>{statuses[jobDetails?.statusId].name}</span></Typography>
                        </Grid>
                    </Grid>}
                {jobDetails?.jobDescription &&
                    <Grid container>
                        <Grid size={6}>
                            <Typography sx={{ textAlign: "right", pr: 2 }} variant="body1" >Description:</Typography>
                        </Grid>
                        <Grid size={6}>
                            <Typography variant="body1" ><span style={{ color: "blue" }}>{jobDetails?.jobDescription}</span></Typography>
                        </Grid>
                    </Grid>}
                {jobDetails?.dateTimeReceived &&
                    <Grid container>
                        <Grid size={6}>
                            <Typography sx={{ textAlign: "right", pr: 2 }} variant="body1" >Booked:</Typography>
                        </Grid>
                        <Grid size={6}>
                            <Typography variant="body1" ><span style={{ color: "blue" }}>{new Date(jobDetails?.dateTimeReceived).toISOString().split("T")[0]} {new Date(jobDetails?.dateTimeReceived).toLocaleTimeString("en-GB")}</span></Typography>
                        </Grid>
                    </Grid>}
                {job?.dateTimeOriginalRequired &&
                    <Grid container>
                        <Grid size={6}>
                            <Typography sx={{ textAlign: "right", pr: 2 }} variant="body1" >Original Appoint.:</Typography>
                        </Grid>
                        <Grid size={6}>
                            <Typography variant="body1" ><span style={{ color: "blue" }}>{new Date(job?.dateTimeOriginalRequired).toISOString().split("T")[0]} {jobDetails?.originalAppointmentTimeTypeName}</span></Typography>
                        </Grid>
                    </Grid>}
                {jobDetails?.appointmentTimeTypeName &&
                    <Grid container>
                        <Grid size={6}>
                            <Typography sx={{ textAlign: "right", pr: 2 }} variant="body1" >Current Appoint.:</Typography>
                        </Grid>
                        <Grid size={6}>
                            <Typography variant="body1" ><span style={{ color: "blue" }}>{new Date(jobDetails.dateTimeRequired || 0).toISOString().split("T")[0]} {jobDetails.appointmentTimeTypeName}</span></Typography>
                        </Grid>
                    </Grid>}
                {jobDetails?.paymentMethodId !== 0 &&
                    <Grid container>
                        <Grid size={6}>
                            <Typography sx={{ textAlign: "right", pr: 2 }} variant="body1" >Paying By:</Typography>
                        </Grid>
                        <Grid size={6}>
                            <Typography variant="body1" ><span style={{ color: "blue" }}>{jobDetails?.paymentMethod}</span></Typography>
                        </Grid>
                    </Grid>}
                {jobDetails?.storedCard &&
                    <Grid container>
                        <Grid size={6}>
                            <Typography sx={{ textAlign: "right", pr: 2 }} variant="body1" >Card stored?:</Typography>
                        </Grid>
                        <Grid size={6}>
                            <Typography variant="body1" ><span style={{ color: "blue" }}>{jobDetails?.storedCard}</span></Typography>
                        </Grid>
                    </Grid>}
                {jobDetails?.coverage !== null &&
                    <Grid container>
                        <Grid size={6}>
                            <Typography sx={{ textAlign: "right", pr: 2 }} variant="body1" >Coverage:</Typography>
                        </Grid>
                        <Grid size={6}>
                            <Typography variant="body1" ><span style={{ color: "blue" }}>{jobDetails?.coverage}%</span></Typography>
                        </Grid>
                    </Grid>}
                {jobDetails?.callTypeDescription !== null &&
                    <Grid container>
                        <Grid size={6}>
                            <Typography sx={{ textAlign: "right", pr: 2 }} variant="body1" >Call Type:</Typography>
                        </Grid>
                        <Grid size={6}>
                            <Typography variant="body1" ><span style={{ color: "blue" }}>{jobDetails?.callTypeDescription}</span></Typography>
                        </Grid>
                    </Grid>}
            </CardContent>
        </Card >)
    );
}

BookingCard.displayName = name

export default React.memo(BookingCard)

